// extracted by mini-css-extract-plugin
export var description = "ButtonWithMenu-module--description--gOziE";
export var fadeIn = "ButtonWithMenu-module--fadeIn--gf0k0";
export var label = "ButtonWithMenu-module--label--oRaqK";
export var link = "ButtonWithMenu-module--link--2+o18";
export var radio = "ButtonWithMenu-module--radio--it3+L";
export var title = "ButtonWithMenu-module--title--2oDx-";